import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i44667841__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M20.207.118a1.35 1.35 0 0 0-1.402.26L17.143 1.93 15.48.38a1.35 1.35 0 0 0-1.818 0L12 1.93 10.338.38a1.35 1.35 0 0 0-1.818 0L6.857 1.93 5.195.38a1.35 1.35 0 0 0-1.402-.26C3.313.302 3 .741 3 1.226v21.598c0 .485.312.924.793 1.109.481.187 1.034.084 1.402-.26l1.662-1.552 1.663 1.551a1.35 1.35 0 0 0 1.818 0L12 22.122l1.662 1.551a1.35 1.35 0 0 0 1.818 0l1.663-1.551 1.662 1.551c.246.23.575.352.91.352.165 0 .332-.029.492-.091.48-.185.793-.624.793-1.109V1.227c0-.485-.312-.924-.793-1.109m-4.35 17.907H8.143c-.711 0-1.286-.536-1.286-1.2s.575-1.2 1.286-1.2h7.714c.711 0 1.286.537 1.286 1.2 0 .664-.575 1.2-1.286 1.2m0-4.8H8.143c-.711 0-1.286-.535-1.286-1.199s.575-1.2 1.286-1.2h7.714c.711 0 1.286.537 1.286 1.2s-.575 1.2-1.286 1.2m0-4.799H8.143c-.711 0-1.286-.536-1.286-1.2s.575-1.2 1.286-1.2h7.714c.711 0 1.286.537 1.286 1.2 0 .664-.575 1.2-1.286 1.2"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i44667841__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .026h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }